import { apiClient } from '@/shared/api';
import type { ApiError } from '@/shared/types';
import type { Result } from '@/shared/types';
import type { UpdateSettingsRequest, UserSettings } from './types';

export function fetchSettings(): Promise<Result<UserSettings, ApiError>> {
  return apiClient.get<UserSettings>('/api/settings');
}

export function updateSettings(
  request: UpdateSettingsRequest,
): Promise<Result<UserSettings, ApiError>> {
  return apiClient.put<UserSettings>('/api/settings', request);
}
